export default {
  // Set training loaded state to true
  trainingTimestamp(state) {
    state.trainingLoaded = String(Math.round(new Date().getTime() / 1000));
  },
  // Set enrollments loaded state to true
  enrollmentsLoaded(state) {
    state.enrollmentsLoaded = String(Math.round(new Date().getTime() / 1000));
  },
  trainingTimestampReset(state) {
    state.trainingLoaded = null;
    state.enrollmentsLoaded = null;
  },
  // Set module state
  modules(state, payload) {
    state.modules = payload;
  },
  // Set learning content staete
  learningContent(state, payload) {
    state.learningContent = payload.slice().sort((a, b) => {
      const orderA = a.order ?? Infinity;
      const orderB = b.order ?? Infinity;
      return orderA - orderB;
    });
  },
  // Set competeny tests
  competencyTests(state, payload) {
    state.competencyTests = payload;
  },
  // Set enrollments
  enrollments(state, payload) {
    state.enrollments = payload;
  },
  // add required Actions
  addRequiredAction(state, payload) {
    if (
      !state.requiredActions.find(
        (action) =>
          (action.type == "competency_no_meeting" &&
            action.enrollmentId == payload.enrollmentId) ||
          (action.type == "module_review" &&
            action.moduleId == payload.moduleId)
      )
    ) {
      state.requiredActions.push(payload);
    }
  },
  // remove a required action
  removeRequiredAction(state, actionId) {
    state.requiredActions = state.requiredActions.filter(
      (action) => action.id != actionId
    );
  },
  // Mark a specifid enrollment completed
  enrollmentCompletedTimestamp(state, payload) {
    for (let i = 0; i < state.enrollments.length; i++) {
      if (state.enrollments[i].enrollmentId == payload.enrollmentId) {
        state.enrollments[i].completedTimestamp = payload.completedTimestamp;
        break;
      }
    }
  },
  // Reviews and updates the status of an enrollment
  updateEnrollmentStatus(state, enrollmentId) {
    for (let i = 0; i < state.enrollments.length; i++) {
      if (state.enrollments[i].enrollmentId == enrollmentId) {
        let totalCompleted = 0;
        for (let j = 0; j < state.enrollments[i].learningContent.length; j++) {
          if (state.enrollments[i].learningContent[j].status == "completed") {
            totalCompleted = totalCompleted + 1;
          }
        }
        for (let j = 0; j < state.enrollments[i].competencyTests.length; j++) {
          if (state.enrollments[i].competencyTests[j].status == "completed") {
            totalCompleted = totalCompleted + 1;
          }
        }
        state.enrollments[i].totalCompleted = totalCompleted;
      }
    }
  },
};
